<template>
  <div class="login-page">
    <div class="login-page-bg" aria-hidden="true">
      <div class="login-page-glow login-page-glow--top"></div>
      <div class="login-page-glow login-page-glow--bottom"></div>
      <div class="login-page-grid"></div>
    </div>

    <div class="login-page-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/assets/sass/pages/login/login-1.scss';
</style>

<script>
const LOGIN_BODY_CLASS = 'login-page-active';

export default {
  name: 'auth',
  mounted() {
    document.body.classList.add(LOGIN_BODY_CLASS);
  },
  beforeDestroy() {
    document.body.classList.remove(LOGIN_BODY_CLASS);
  },
};
</script>
